module.exports = __webpack_public_path__ + "img/Rene.016c8430.jpg";